import React from "react";
import { Link } from "react-router-dom";
import { ROUTE_NAMES } from "../../../routes/routeConstants";
import { useAuth } from "../../../provider/AuthProvider";
import { useLoginModal } from "../../../context/LoginModalContext";
import { P, PAGE_MAX, PAGE_PAD } from "./shell";
import { VELLUM as T, display, mono, body, btn } from "./tokens";

/* The close. The spine ends above this section and the sheet opens out to
   full width: the folio shuts. Both parties get the same measure, the same
   heading scale and the same button, because neither one is the guest. */

export const Close: React.FC = () => {
  const { user } = useAuth();
  const { openRegisterModal } = useLoginModal();

  const cta = (label: string, to: string) =>
    user ? (
      <Link to={to} className={`${P}-accent`} style={{ ...btn(T, "accent"), marginTop: 24, textDecoration: "none" }}>
        {label}
      </Link>
    ) : (
      <button type="button" onClick={openRegisterModal} className={`${P}-accent`} style={{ ...btn(T, "accent"), marginTop: 24 }}>
        {label}
      </button>
    );

  return (
    <section style={{ maxWidth: PAGE_MAX, margin: "0 auto", padding: `0 ${PAGE_PAD}px 46px` }}>
      <div style={{ borderTop: `3px solid ${T.ink}`, paddingTop: 42 }} />

      <div className={`${P}-doors`} style={{ display: "grid", gridTemplateColumns: "1fr 1px 1fr", columnGap: 48 }}>
        <div>
          <div style={{ ...mono(T, T.accent), marginBottom: 14 }}>Scholars</div>
          <h2 style={display(T, "clamp(28px, 3.4vw, 38px)")}>Read the register.</h2>
          <p style={{ ...body(T), fontSize: 16, marginTop: 16, maxWidth: 420 }}>
            Free, and staying free. Keep a profile in the register's own vocabulary and search the
            field map by the subfield you actually work in.
          </p>
          {cta("Take an account", ROUTE_NAMES.PAGES.JOBS)}
        </div>

        <div aria-hidden className={`${P}-doors-rule`} style={{ background: T.rule, width: 1 }} />

        <div>
          <div style={{ ...mono(T, T.accent), marginBottom: 14 }}>Institutions</div>
          <h2 style={display(T, "clamp(28px, 3.4vw, 38px)")}>Post a position.</h2>
          <p style={{ ...body(T), fontSize: 16, marginTop: 16, maxWidth: 420 }}>
            Free while the register is being built. Your post is filed by subfield, level and role,
            and read by the people who do that exact work.
          </p>
          {cta("Post a position", ROUTE_NAMES.PAGES.POST_JOB)}
        </div>
      </div>

      <div
        style={{
          ...mono(T),
          display: "flex",
          justifyContent: "space-between",
          gap: 20,
          flexWrap: "wrap",
          marginTop: 46,
          paddingTop: 18,
          borderTop: `1.5px solid ${T.ink}`,
        }}
      >
        <span>Acanetic · Register of academic posts</span>
        <span>London &amp; Cambridge · Founded 2024</span>
      </div>
    </section>
  );
};
